// extracted by mini-css-extract-plugin
module.exports = {"draftTag":"DraftTag_draftTag__LwYZt"};